import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLinodeComponent } from './simple-icons-linode.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLinodeComponent ],
    exports:      [ SimpleIconsLinodeComponent ],
    bootstrap:    []
})
export class SimpleIconsLinodeModule {}
